import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { parsePhoneNumberFromString } from "libphonenumber-js";

function formatPhoneNumber(phoneNumber: string) {
  try {
    const phone = parsePhoneNumberFromString(phoneNumber);
    return phone ? phone.formatInternational() : phoneNumber;
  } catch {
    return phoneNumber;
  }
}

export function SettingsSMS() {
  const [phoneNumber, setPhoneNumber] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      try {
        const response = await fetch("/api/twilio");

        if (response.ok) {
          const data = await response.json();
          setPhoneNumber(data.twilio?.phoneNumber || null);
        } else {
          console.error("Failed to fetch Twilio configuration");
        }
      } catch (error) {
        console.error("Failed to fetch data:", error);
      } finally {
        setIsLoading(false);
      }
    }

    fetchData();
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[40vh]">
        <Loader2 className="animate-spin h-12 w-12 text-muted-foreground" />
      </div>
    );
  }

  if (!phoneNumber) {
    return (
      <div className="max-w-xl space-y-4">
        <p className="text-muted-foreground">
          You don&apos;t have a phone number set up for SMS yet. Reach out to us
          and we&apos;ll get one configured for your artist.
        </p>
        <Button asChild>
          <a href="mailto:hello@engram.sh">Contact Us</a>
        </Button>
      </div>
    );
  }

  return (
    <div className="max-w-2xl space-y-2">
      <Label>Phone Number</Label>
      <p className="text-sm">{formatPhoneNumber(phoneNumber)}</p>
    </div>
  );
}
